const OrderedTimeUnits = ['MINUTES', 'HOURS', 'DAYS', 'WEEKS'];
const defaults = {
  timeUnit: 'HOURS',
  numberOfTimeUnits: 1
};
export default class Reminder {
  constructor(props) {
    var _props$timeUnit, _props$numberOfTimeUn;
    this.timeUnit = (_props$timeUnit = props === null || props === void 0 ? void 0 : props.timeUnit) !== null && _props$timeUnit !== void 0 ? _props$timeUnit : defaults.timeUnit;
    this.numberOfTimeUnits = (_props$numberOfTimeUn = props === null || props === void 0 ? void 0 : props.numberOfTimeUnits) !== null && _props$numberOfTimeUn !== void 0 ? _props$numberOfTimeUn : defaults.numberOfTimeUnits;
    if ((props === null || props === void 0 ? void 0 : props.ticks) !== undefined) this.ticks = props.ticks;
  }
  static from(json) {
    if (json) {
      return new Reminder({
        timeUnit: json.timeUnit || defaults.timeUnit,
        numberOfTimeUnits: json.numberOfTimeUnits || defaults.numberOfTimeUnits
      });
    }
    return new Reminder();
  }
  static compare(a, b) {
    if (OrderedTimeUnits.indexOf(a.timeUnit) !== OrderedTimeUnits.indexOf(b.timeUnit)) {
      return OrderedTimeUnits.indexOf(a.timeUnit) - OrderedTimeUnits.indexOf(b.timeUnit);
    } else {
      return a.numberOfTimeUnits - b.numberOfTimeUnits;
    }
  }
}